import { MetaFunction } from "@vercel/remix"

export const meta: MetaFunction = () => {
  return [{ title: "Video as a Solution" }]
}

export default function Index() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold">
        Data Protocol Video as a Solution
      </h1>
    </div>
  )
}
